/**
 * RecordingApi.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


import Recorder from './Recorder';
import MediaDevices from './MediaDevices';


/**
 * @typedef {{
 *   mediaDevices: IDeviceManager,
 *   Recorder: Function,
 *   getTechnology: function (): string,
 * }} PluginRecordingApi
 */

export default class RecordingApi {
    /**
     * Creates a RecordingApi instance.
     *
     * @param {PluginRecordingApi} pluginContext Plugin context
     */
    constructor(pluginContext) {
        this.pluginContext = pluginContext;
        this.mediaDevices = new MediaDevices(pluginContext);
        this.Recorder = Recorder.bind(null, pluginContext);
    }

    /**
     * @return {string}
     */
    getTechnology() {
        return this.pluginContext.getTechnology();
    }
}
